import React from 'react';
import moment from 'moment';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faTimesCircle} from '@fortawesome/pro-solid-svg-icons/faTimesCircle';

import Base from 'Components/Base/Base';
import {PreAuth} from 'Components/Partials/Layouts';
import Alert from 'Components/Partials/Layouts/Alert';
import {Button, InputField, Label} from 'Components/Partials/Form';

import GuestCheckIn from 'Services/Api/Guests/CheckIn';

export default class GuestCheckin extends Base {
    /**
     * @var state
     * @type {{form: {name: string}, alert: null, working: boolean}}
     */
    state = {
        form: {
            name: ''
        },
        alert: null,
        working: false
    };

    /**
     * @method componentDidMount
     */
    componentDidMount = () => {
        let guest = localStorage.getItem('guest');

        if (guest !== undefined) {
            guest = JSON.parse(guest);

            this.setState({
                guest,
            });
        }
    };

    /**
     * @method handleSubmit
     * @param {Event} e
     * @return {Promise<void>}
     */
    handleSubmit = async (e) => {
        e.preventDefault();
        this.working();

        const request = await GuestCheckIn.submit(this.state.form);

        if (request.status !== 200 && request.status !== 201) {
            return this.formErrors(request.message, request.errors);
        }

        this.setState({
            guest: request.data.data,
            form: {
                name: '',
            },
        });
        localStorage.setItem('guest', JSON.stringify(request.data.data));

        return this.formSuccess('Thank you for checking in, please remember to checkout when you leave');
    };

    /**
     * @method handleCheckout
     * @return {Promise<void>}
     */
    handleCheckout = async () => {
        this.working();
        const request = await GuestCheckIn.checkOut(this.state.guest.id);

        if (request.status !== 200) {
            return this.formErrors(request.message, request.errors);
        }

        this.setState({
            guest: null,
            checkingOut: false
        });
        localStorage.removeItem('guest');

        return this.formSuccess('Thank you for checking out, we look forward to seeing you again soon');
    };

    /**
     * @method handleAskToCheckout
     */
    handleAskToCheckout = () => {
        this.setState({
            checkingOut: !this.state.checkingOut
        });
    };

    /**
     * @method render
     * @return {JSX.Element}
     */
    render () {
        const {form, alert, working, guest, checkingOut} = this.state;

        return (
            <PreAuth mode="guest-checkin">
                {alert && (<div className="mt-6"><Alert {...alert} /></div>)}

                {checkingOut && (
                    <React.Fragment>
                        <p className="font-thin text-center my-8">
                            Are you sure you want to checkout?
                        </p>

                        <div className="flex justify-center">
                            <Button
                                label="Cancel"
                                working={working}
                                className="mr-2"
                                onClick={this.handleAskToCheckout}
                            />
                            <Button
                                label="Continue"
                                classKey="dangerButton"
                                working={working}
                                onClick={this.handleCheckout}
                            />
                        </div>
                    </React.Fragment>
                )}

                {!checkingOut && (
                    <React.Fragment>
                        {guest && (
                            <React.Fragment>
                                <div
                                    className="mt-6 login-profile cursor-pointer block hover:bg-gray-50 focus:outline-none focus:bg-gray-50 transition duration-150 ease-in-out relative"
                                >
                                    <div
                                        className="absolute top-0 right-0 -mt-6 -mr-6 p-4"
                                        onClick={this.handleAskToCheckout}
                                    >
                                        <FontAwesomeIcon
                                            icon={faTimesCircle}
                                            size="lg"/>
                                    </div>
                                    <div
                                        className="flex items-center px-4 py-4 sm:px-6"
                                    >
                                        <div
                                            className="min-w-0 flex-1 flex items-center">
                                            <div
                                                className="min-w-0 flex-1 px-4">
                                                <div>
                                                    <div className="text-sm leading-5 font-medium text-app-blue-light truncate">
                                                        Checked in at: {moment(guest.checked_in).format("DD/MM/YY HH:mm")}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </React.Fragment>
                        )}

                        {!guest && (
                            <React.Fragment>
                                <p className="font-thin mb-8 lg:hidden mt-8">
                                    Welcome to Tuthill Porsche, please sign in below
                                </p>

                                <form onSubmit={this.handleSubmit}>
                                    <div className="my-6">
                                        <Label label="Your Name" htmlFor="your_name"/>

                                        <div className="mt-1 rounded-md shadow-sm">
                                            <InputField
                                                type="text"
                                                id="your_name"
                                                value={form.name}
                                                onChange={(e) => this.handleFormInput('name', e.target.value)}
                                            />
                                        </div>
                                    </div>

                                    <Button
                                        label="Submit"
                                        working={working}
                                    />
                                </form>
                            </React.Fragment>
                        )}
                    </React.Fragment>
                )}
            </PreAuth>
        );
    }
}
